import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgOpenIn(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-rtl-mirror": true }, props),
        React.createElement("path", { d: "M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V15C22 14.4477 21.5523 14 21 14C20.4477 14 20 14.4477 20 15V20H4V4H9C9.55228 4 10 3.55228 10 3C10 2.44772 9.55228 2 9 2H4Z", fill: "currentColor" }),
        React.createElement("path", { d: "M21.0037 9.95325C20.4535 9.95325 20.0075 9.50721 20.0075 8.95699V5.40146L12.7007 12.7082C12.3117 13.0973 11.6809 13.0973 11.2918 12.7082C10.9027 12.3191 10.9027 11.6883 11.2918 11.2993L18.5985 3.99253H15.043C14.4928 3.99253 14.0467 3.54648 14.0467 2.99626C14.0467 2.44604 14.4928 2 15.043 2H20.0075C21.1079 2 22 2.89209 22 3.99253V8.95699C22 9.50721 21.554 9.95325 21.0037 9.95325Z", fill: "currentColor" })));
}
export default SvgOpenIn;
